import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'css-reset'
import '@/style/index.scss'
import Toast from '@/components/toast'

Vue.config.productionTip = false
Vue.use(Toast)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
